import React, { useEffect, useState } from "react";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import {
  getPlaybackRateOptionLabel,
  videoPlaybackRates
} from "../../helpers/playbackRates";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { MenuHeader } from "../settings/MenuHeader";
import {
  Divider,
  InputLabel,
  SettingInput,
  SettingMenu,
  SettingOption
} from "../settings/styles";
import { TopLevelSettingOption } from "../settings/TopLevelSettings";

type OptionsProps = {
  onClickBack: () => void;
  onBlur: (event) => void;
};

export const PlaybackRateOptions = ({ onBlur, onClickBack }: OptionsProps) => {
  const { useStoreState } = usePlayerStore();
  const isLiveEdge = useStoreState.isLiveEdge();
  const playbackRate = useStoreState.playbackRate();
  const player = useStoreState.player();
  const uiSize = useStoreState.uiSize();

  const { language } = useEmbedParametersContext();

  const [playbackRateOptions, setPlaybackRateOptions] =
    useState(videoPlaybackRates);

  useEffect(() => {
    if (!videoPlaybackRates.includes(playbackRate)) {
      setPlaybackRateOptions([playbackRate, ...videoPlaybackRates]);
    }
  }, [playbackRate]);

  return (
    <>
      <MenuHeader backToTopLevel={onClickBack} label="toistonopeus" />
      <Divider />
      <SettingMenu role="menu">
        {playbackRateOptions.map(item => (
          <SettingOption key={item}>
            <SettingInput
              checked={playbackRate === item}
              disabled={isLiveEdge && item > 1}
              id={`playback-rate-setting-${item}`}
              name="playback-rate"
              onBlur={onBlur}
              onChange={() => player.setPlaybackRate(item)}
              onClick={onClickBack}
              value={item}
            />
            <InputLabel
              htmlFor={`playback-rate-setting-${item}`}
              uiSize={uiSize}>
              {getPlaybackRateOptionLabel(item, videoPlaybackRates, language)}
            </InputLabel>
          </SettingOption>
        ))}
      </SettingMenu>
    </>
  );
};

type TopLevelOptionProps = {
  autoFocus?: boolean;
  onBlur: (event: React.FocusEvent<HTMLElement>) => void;
  onClick: () => void;
};

export const PlaybackRateTopLevelOption = ({
  autoFocus,
  onBlur,
  onClick
}: TopLevelOptionProps) => {
  const { useStoreState } = usePlayerStore();
  const playbackRate = useStoreState.playbackRate();
  const { language } = useEmbedParametersContext();

  return (
    <TopLevelSettingOption
      autoFocus={autoFocus}
      onBlur={onBlur}
      onClick={onClick}
      title={i18n("toistonopeus", { language })}
      value={getPlaybackRateOptionLabel(
        playbackRate,
        videoPlaybackRates,
        language
      )}
    />
  );
};
